module.exports = __webpack_public_path__ + "posture/static/img/round_shoulder_normal.9f9d5a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/normal/round_shoulder_normal.png
// module id = vZf5
// module chunks = 1